$(document).on('render:teams', () => {
  if ($('body').attr('data-action') !== 'technology') return

  document.querySelector('.back_btn').style.display = 'flex'
})
